import { DeserializedCompanyUser } from '@/src/lib/company-user/types';

export function companyBusinessUnitHasPriceReferences(companyUsers: Array<DeserializedCompanyUser>) {
  return companyUsers
    .flatMap((companyUser) => companyUser.companyBusinessUnits)
    .some(
      (companyBusinessUnit) =>
        companyBusinessUnit.priceReferenceProjectNumbers?.length || companyBusinessUnit.priceReferenceQuoteIds?.length,
    );
}

export function isAccountModalAvailable(companyUsers: Array<DeserializedCompanyUser>) {
  return companyUsers.length > 1 || companyBusinessUnitHasPriceReferences(companyUsers);
}
